import Index from '../../views/setting/reason/Index'
import List from '../../views/setting/reason/List'
import Permissions from '@/permissions'

export const reasonRouters = {
  path: 'reason',
  component: Index,
  redirect: '',
  meta: {
    permissions: [Permissions.backend.setting.reason.manage],
    groups: 'reason'
  },
  children: [
    {
      path: '',
      name: 'list-reason',
      component: List,
      meta: {
        permissions: [Permissions.backend.setting.reason.list],
        groups: 'reason',
        breadcrumb: [
          {
            name_en: 'Setting',
            name_km: 'ការកំណត់'
          },
          {
            name_en: 'Reason',
            name_km: 'ហេតុផល'
          },
          {
            name_en: 'List',
            name_km: 'បញ្ជី'
          }
        ]
      }
    }
  ]
}
